(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rife-charging-phase1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-rcp1-open]');
  if (trigger) {
    const section = trigger.closest('.rcp1');
    const dialog = section ? section.querySelector('[data-rcp1-lightbox]') : null;
    const image = dialog ? dialog.querySelector('[data-rcp1-lightbox-image]') : null;
    if (dialog && image) {
      image.src = trigger.dataset.full || '';
      image.alt = trigger.dataset.alt || '';
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
    }
    return;
  }

  const close = event.target.closest('[data-rcp1-close]');
  if (close) {
    const dialog = close.closest('[data-rcp1-lightbox]');
    if (dialog) dialog.close();
    return;
  }

  const dialog = event.target.closest('[data-rcp1-lightbox]');
  if (dialog && event.target === dialog) {
    dialog.close();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rife-tv-trolley-premium"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const open = event.target.closest('.rtvp-open');
  if (open) {
    const root = open.closest('[data-rtvp-product]');
    const dialog = root ? root.querySelector('[data-rtvp-dialog]') : null;
    const image = dialog ? dialog.querySelector('[data-rtvp-image]') : null;
    if (dialog && image) {
      image.src = open.dataset.rtvpSrc;
      dialog.showModal();
    }
  }
  const close = event.target.closest('[data-rtvp-close]');
  if (close) {
    const dialog = close.closest('dialog');
    if (dialog) dialog.close();
  }
  if (event.target.matches('dialog.rtvp-lightbox')) event.target.close();
});

  } catch(e) { console.error(e); }
})();
})();
